export default {

	refreshTokenUrl: 'auth/refreshtoken',
	// Option to turn refresh tokens On/Off
	useRefreshToken: true,
	// The option to enable/disable the automatic refresh of Auth tokens using Refresh Tokens
	autoUpdateToken: true,
	endpoint: 'auth',
	configureEndpoints: ['auth', 'protected-api'],
	//loginUrl: 'auth/login',
	signupUrl: 'register',
	profileUrl: 'me',
	// The SPA url to which the user is redirected after a successful login
	loginRedirect: '#/app',
	unlinkUrl: 'me/unlink',
	loginOnSignup: true,
	httpInterceptor: true,
	storageChangedReload: false,    // ensure secondary tab reloading after auth status changes
	expiredRedirect: '#/expired',            // redirect to logoutRedirect after token expiration
	providers: {
		google: {
			url: 'google',
			clientId: '239531536023-ibk10mb9p7ullsw4j55a61og5lvnjrff6.apps.googleusercontent.com'
		},
		facebook: {
			url: 'facebook',
			clientId: '1465278217541708498'
		}
	}
	

};
